import React, { Component } from 'react';
import { translate } from 'react-i18next';

// Components
import CustomModal from 'components/CustomModal/index';
import { InputTextArea } from 'components/Fields';

// Styles
import * as modalStyles from 'components/CustomModal/styles';

class RejectModal extends Component {
  constructor() {
    super();
    this.state = { rejectMessage: null };
    this.onConfirm = this.onConfirm.bind(this);
  }

  componentDidUpdate(nextProps) {
    const { isOpen } = this.props;
    const { rejectMessage } = this.state;
    if (!isOpen && nextProps.isOpen && rejectMessage) {
      this.setState({ rejectMessage: null });
    }
  }

  onConfirm() {
    const { rejectMessage } = this.state;
    const { onReject } = this.props;
    onReject && onReject(rejectMessage);
  }

  render() {
    const { isOpen, closeModal, i18n, isResolved } = this.props;
    return (
      <CustomModal
        isOpen={isOpen}
        onRequestClose={closeModal}
        style={{ content: { maxWidth: '33em', padding: 0 } }}
      >
        <modalStyles.CommonModalWrapper>
          {/* ──── Header ───────────────────────────────────────────────────────────────────── */}
          <modalStyles.ModalBlockSection className="header-wrapper">
            <modalStyles.ModalCloseIcon className="close-icon" onClick={closeModal} />
            <modalStyles.ModalTitle>
              {i18n.t('reject_unplanned_appointment')}
            </modalStyles.ModalTitle>
          </modalStyles.ModalBlockSection>

          {/* ──── Content ───────────────────────────────────────────────────────────────────── */}
          <modalStyles.ModalBlockSection
            borderBottom
            className="optional"
            style={{ marginBottom: '.3em' }}
          >
            <span style={{ fontSize: '1.1em' }}>
              {i18n.t('reject_unplanned_appointment_confirm_text')}
            </span>
          </modalStyles.ModalBlockSection>
          <modalStyles.ModalBlockSection
            borderBottom
            className="optional"
            style={{ marginBottom: '.3em' }}
          >
            <InputTextArea
              label={i18n.t('note_text_area_label')}
              placeholder={i18n.t('leave_note_here')}
              optional
              input={{
                onChange: e => this.setState({ rejectMessage: e.target.value })
              }}
            />
          </modalStyles.ModalBlockSection>

          {/* ──── Footer ────────────────────────────────────────────────────────────────────── */}

          <modalStyles.ModalFooter className="footer">
            <modalStyles.ModalCancel onClick={closeModal}>
              {i18n.t('cancel')}
            </modalStyles.ModalCancel>

            <modalStyles.ModalFooterBtn
              disabled={isResolved}
              style={{ minWidth: '200px' }}
              onClick={this.onConfirm}
            >
              {i18n.t('reject')}
            </modalStyles.ModalFooterBtn>
            {isResolved ? (
              <span className="resolve-message">{i18n.t('event_was_resolved')}</span>
            ) : null}
          </modalStyles.ModalFooter>
        </modalStyles.CommonModalWrapper>
      </CustomModal>
    );
  }
}

export default translate()(RejectModal);
